<script setup lang="ts">
  import useCpBem from '~/composables/useCpBem';
  import type {ICatMan} from '~/types';
  import CpText from '~/components/cp/CpText/CpText.vue';

  defineProps<{
    category: ICatMan,
    selected: boolean
  }>();
  defineEmits<{
    (e:'select-category', id: string): void
  }>();
  const {bm} = useCpBem('cp-nav-menu-main-cat-card');
</script>

<template>
    <div :class="bm({'active': selected})" role="button" data-testid="nav-menu-main-cat" @click="$emit('select-category', category.id)">
        <CpText variant="body-regular" :type="selected ? 'primary': 'white'" align="center">
            {{ category.title }}
        </CpText>
    </div>
</template>

<style scoped lang="scss">
  .cp-nav-menu-main-cat-card {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 64px;
    padding: $cp-gutter $cp-gutter-small;
    cursor: pointer;

    &--active {
      background-color: var(--color-white);
    }
    &__txt {
      text-align: center;
    }
  }
</style>
